import { PointsVaultActivitiesResponse } from "../../types";

export const getPVUsersModelCreator = (response: PointsVaultActivitiesResponse): PointsVaultActivitiesResponse =>
  response;
